// Libraries
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Box } from "@material-ui/core";
import classNames from "classnames";
import { useObserver } from "mobx-react-lite";
import React from "react";
import { BQSAlertDialogStyle } from "./BQSAlertDialogStyle";

interface IProps {
    className?: string;
    canDisplay: boolean;
    displayName: string;
    displayContentLine1: string;
    displayContentLine2: string;
    execute: () => void;
}

export const BQSAlertDialog: React.FC<IProps> = (props: IProps) => {
    // #region Code Behind
    const bqsAlertDialogStyle = BQSAlertDialogStyle();
    // #endregion Code Behind

    // #region Render Result

    return useObserver(() => (
        <Dialog
            className={bqsAlertDialogStyle.root}
            open={props.canDisplay}
            onClose={props.execute}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogTitle className={bqsAlertDialogStyle.title} id="alert-dialog-title">
                <span className={bqsAlertDialogStyle.titletext}>{props.displayName}</span>
            </DialogTitle>
            <DialogContent className={bqsAlertDialogStyle.description}>
                <Box>
                    <DialogContentText id="alert-dialog-description">{props.displayContentLine1}</DialogContentText>
                </Box>
                <Box>
                    <DialogContentText id="alert-dialog-description">{props.displayContentLine2}</DialogContentText>
                </Box>
            </DialogContent>
            <DialogActions>
                <Button className={bqsAlertDialogStyle.btn} onClick={props.execute}>
                    OK
                </Button>
            </DialogActions>
        </Dialog>
    ));

    // #endregion Render Result
};
